import { render, staticRenderFns } from "./AppointmentRemindersSettings.vue?vue&type=template&id=f4726856&scoped=true"
import script from "./AppointmentRemindersSettings.vue?vue&type=script&lang=js"
export * from "./AppointmentRemindersSettings.vue?vue&type=script&lang=js"
import style0 from "./AppointmentRemindersSettings.vue?vue&type=style&index=0&id=f4726856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4726856",
  null
  
)

export default component.exports